import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import {
  CfFtpInfo,
  CfFtpInfoMenuActionsType,
} from 'data/cfFtpInfo/cfFtpInfo.types';
import './cf-ftp-info-action-menu.scss';

type Props = {
  selectedItem?: CfFtpInfo;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

const CfFtpInfoMenu: FunctionComponent<Props> = ({
  selectedItem,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedItem == null) {
    return null;
  }

  return (
    <div data-testid="CfFtpInfoMenu" className="cf-ftp-info-action-menu">
      {hasPrivilegesToCreate && (
        <Button
          className="cf-ftp-info-action-menu-button"
          data-testid={`${CfFtpInfoMenuActionsType.Edit}-button`}
          text={t('cfFtpInfo.grid.edit')}
          onClick={onEdit}
        />
      )}
      {hasPrivilegeToDelete && (
        <Button
          className="cf-ftp-info-action-menu-button"
          data-testid={`${CfFtpInfoMenuActionsType.Delete}-button`}
          text={t('cfFtpInfo.grid.delete')}
          onClick={handleOpenDeleteDialog}
        />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('cfFtpInfo.deletePopup.title')}
        displayMessage={
          t('cfFtpInfo.deletePopup.message', { name: selectedItem.FTPID })
        }
        actionText={t('cfFtpInfo.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default CfFtpInfoMenu;
